
const patterns = [
    "data/pattern/1.jpg",
    "data/pattern/2.jpg",
    "data/pattern/3.jpg",
    "data/pattern/4.jpg",
    "data/pattern/5.jpg",
    "data/pattern/6.jpg",
    "data/pattern/7.jpg",
    "data/pattern/8.jpg",
    "data/pattern/9.png",
    "data/pattern/10.png",
    "data/pattern/11.jpg",
    "data/pattern/12.jpg",
    "data/pattern/13.jpg",
    "data/pattern/14.jpg",
    "data/pattern/15.jpg",
    "data/pattern/16.jpg",
    "data/pattern/17.jpg",
    "data/pattern/18.jpg",
    "data/pattern/19.png",
    "data/pattern/20.jpg",
    "data/pattern/21.png",
    "data/pattern/22.jpg",
    "data/pattern/23.jpg",
    "data/pattern/24.jpg",

]

export default patterns